export enum PendingAreaActionType {
    Approve = 1,
    Cancel = 2,
    Recalculate = 3
}